<template>
    <div>
        <el-table :show-header="false" :data="tableData" style="width: 100%">
            <el-table-column label="a" width="120px" prop="title"></el-table-column>
            <el-table-column label="b" prop="content"> </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    props: {
        tableData: {
            type: Array,
            default: []
        }
    },
    data() {
        return {

        }
    },
}
</script>